import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"

import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import CosViewSelect from '../CosView/select.vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: [String, Number, Array]
  },
  view: {
    type: Boolean
  },
  options: {
    type: Array
  },
  fieldNames: {
    type: Object
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const props = __props
const optionComputed = computed(() => {
  if (props.options) {
    const label = props.fieldNames?.label || 'label'
    props.options?.forEach((item: any) => {
      if (item.lang) {
        item[label] = t(item.lang)
      }
    })
  }
  return props.options
})
const emit = __emit
const modelValue = useVModel(props, 'value', emit)

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (__props.view && __props.options)
    ? (_openBlock(), _createBlock(CosViewSelect, _mergeProps({
        key: 0,
        fieldNames: __props.fieldNames
      }, _ctx.$attrs, {
        options: optionComputed.value,
        value: __props.value
      }), null, 16, ["fieldNames", "options", "value"]))
    : (_openBlock(), _createBlock(_component_a_radio_group, _mergeProps({ key: 1 }, _ctx.$attrs, {
        fieldNames: __props.fieldNames,
        options: optionComputed.value,
        value: _unref(modelValue),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
        style: {"width":"100%"}
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["fieldNames", "options", "value"]))
}
}

})